/* src/app/shared/components/form-controls/ag-signature/ag-signature.component.scss */
.ag-signature-pad {
  position: relative;
  border: 1px solid #c8c7cc;
  border-radius: 20px;
  overflow: hidden;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.ag-signature-pad.has-errors {
  border: solid 2px #d7263c;
}
.ag-signature-pad.focussed {
  border: solid 2px #61566e;
}
.ag-signature-pad canvas {
  position: absolute;
  z-index: 1;
}
.ag-signature-pad > ag-button {
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 3;
}
.ag-signature-pad img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.5s;
  opacity: 1;
}
.ag-signature-pad img.hidePlaceholder {
  opacity: 0;
}
/*# sourceMappingURL=ag-signature.component.css.map */
